import { useMemo } from 'react';
import { ImportRecord } from '../types';

export const useImportedUsersSearch = (records: ImportRecord[] | undefined, searchTerm: string) => {
  return useMemo(() => {
    if (!records) return [];
    if (!searchTerm) return records;
    
    return records.filter(record => {
      const fullName = `${record.first_name} ${record.last_name}`.toLowerCase();
      const email = record.email.toLowerCase();
      const status = record.status.toLowerCase();
      const search = searchTerm.toLowerCase();
      return fullName.includes(search) || email.includes(search) || status.includes(search);
    });
  }, [records, searchTerm]);
};